import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { ProductPromotionItem } from './product-item'

export const ProductPromotion = () => {
  const { product } = useProductDetailSafe()
  const t = useTranslations('product_detail.title')

  const promotionActive = product?.promotions?.filter(
    (promotion) => promotion.show_in_detail
  )

  if (!promotionActive || promotionActive.length === 0) {
    return null
  }

  return (
    <div
      data-label='product-promotion'
      className='relative mx-auto w-full overflow-hidden rounded-xl border border-[#273BCD] md:mb-4 lg:mb-6'
    >
      {/* Header */}
      <div className='flex w-fit items-center rounded-br-lg rounded-tl-lg bg-gradient-to-r from-[#273BCD] to-[#1C2B9D] px-5 py-1 text-white'>
        <Image
          src={'/icons/icon-gift-promotion.svg'}
          alt='Logo'
          width={20}
          height={20}
          className='mr-2'
        />
        <div className='text-sm'>{t('special_offer_just_for_you')}</div>
      </div>

      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          skipSnaps: false,
        }}
        className='w-full px-4'
      >
        <CarouselContent className='gap-2 px-4 py-4'>
          {promotionActive?.map((promotion, index) => (
            <CarouselItem
              key={promotion.id}
              className={cn(
                'will-change-transform md:basis-3/4 lg:basis-3/5 xl:basis-1/2 2xl:basis-5/12',
                index === 0 || index === promotionActive.length - 1
                  ? 'pl-0'
                  : 'pl-4'
              )}
              data-product-id={promotion.id}
            >
              <ProductPromotionItem product={promotion} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <>
      <CarouselPrevious
        className='absolute -top-1 right-12 h-8 w-8 bg-white text-black hover:bg-neutral-200 lg:right-14'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -top-1 right-2 h-8 w-8 bg-white text-black hover:bg-neutral-200 lg:right-4'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
